import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Paper, Typography } from '@material-ui/core';
import { Sticky, StickyContainer } from 'react-sticky';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import CompanyForm from '../CompanyForm/CompanyForm';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import { useGoToPath } from '../../hooks/useGoToPath';
import { APP_PATH_EDITOR_JOB, APP_PATH_PACKAGE_PLAN } from '../../config';
import CompanyView from '../CompanyView';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 0,
    padding: theme.spacing(4)
  },
  headerSectionView: {
    marginBottom: 10,
    padding: 20
  },
  stepperBtn: {
    textTransform: 'none',
    fontSize: '20px',
    marginRight: theme.spacing(3),
    marginTop: theme.spacing(3)
  },
  titleTopSection: {
    textAlign: 'center',
    paddingTop: 14,
    paddingBottom: 4
  }
}));

const EditorCompanyView = ({ previewTitle }) => {
  const classes = useStyles();
  const {
    onUploadFile,
    onDeleteLogo,
    formValues,
    handleChange,
    handleChangeCustomFieldName,
    hasError,
    file,
    isProcessingLogo,
    formErrors,
    companyLogoUrl,
    isValidForm,
    createCompany,
    updateCompany,
    isEditMode
  } = useCompanyForm();
  const { handleGoToPath } = useGoToPath(APP_PATH_PACKAGE_PLAN);
  const { handleGoToPath: goToJobEditor } = useGoToPath(APP_PATH_EDITOR_JOB);
  const history = useHistory();

  const handleSave = async () => {
    const company = { ...formValues };
    delete company.isValidDraft;
    delete company.fileURLTemporal;
    delete company.publicUrl;

    if (isEditMode) {
      // Update existing company and go back
      updateCompany({ company });
      history.goBack();
    } else {
      // Create new company and continue to next step
      createCompany({ company });
      handleGoToPath();
    }
  };
  return (
    <Paper className={classes.root}>
      <StickyContainer>
        <Grid container spacing={3} direction="row" justifyContent="center">
          <Grid item lg={6} md={6} xl={6} xs={12}>
            <Typography
              className={classes.titleTopSection}
              variant="h2"
              align="center">
              {isEditMode ? 'Edit Company' : 'About your Company'}
            </Typography>
            <CompanyForm
              formErrors={formErrors}
              formValues={formValues}
              handleChangeCustomFieldName={handleChangeCustomFieldName}
              handleChange={handleChange}
              hasError={hasError}
              handleOnUploadFile={onUploadFile}
              fileLogo={file || {}}
              handleOnDeleteFile={onDeleteLogo}
              isProcessingLogo={isProcessingLogo}
              onDeleteLogo={onDeleteLogo}
              onUploadFile={onUploadFile}
            />
          </Grid>
          <Grid item lg={6} md={6} xl={6} xs={12}>
            <Sticky>
              {({ style }) => (
                <div style={style}>
                  <Paper className={classes.headerSectionView} elevation={0}>
                    <Typography variant="h3" align="center">
                      {previewTitle}
                    </Typography>
                  </Paper>
                  <CompanyView
                    isPreview
                    company={formValues}
                    logoUrl={companyLogoUrl}
                  />
                </div>
              )}
            </Sticky>
          </Grid>
        </Grid>
      </StickyContainer>
      <Button
        data-test="next-step-button-assistant"
        className={classes.stepperBtn}
        color="primary"
        disabled={isValidForm}
        onClick={handleSave}
        variant="contained">
        {isEditMode ? 'Save' : 'Continue'}
      </Button>
      {isEditMode ? (
        <Button
          data-test="cancel-button-assistant"
          className={classes.stepperBtn}
          color="default"
          onClick={() => history.goBack()}
          variant="contained">
          Cancel
        </Button>
      ) : (
        <Button
          data-test="back-step-button-assistant"
          className={classes.stepperBtn}
          color="default"
          onClick={() => goToJobEditor()}
          variant="contained">
          Make changes
        </Button>
      )}
    </Paper>
  );
};

EditorCompanyView.defaultProps = {
  previewTitle: 'COMPANY PREVIEW'
};

EditorCompanyView.propTypes = {
  previewTitle: PropTypes.string
};

export default EditorCompanyView;
